// extracted by mini-css-extract-plugin
export default {"step":"SingleStep_step__eQiHO","anchor":"SingleStep_anchor__0W2lg","icon":"SingleStep_icon__JwxLR","title":"SingleStep_title__w+rK4","text":"SingleStep_text__HJlZa"};